import { Box, Typography } from "@mui/material"

import type { FC } from ".."
import { BlogArticleCollection, Container, Pagination } from ".."
import type { BlogArticleTeaserProps } from "../BlogArticleTeaser/BlogArticleTeaser"

type ArticlesCollectionProps = {
  title: string
  totalCount: number
  items: BlogArticleTeaserProps[]
  page: number
  pageCount: number
  onPageChange?: (pageNumber: number) => void
  onLike?: (arg: { contentType?: string; nid?: number }, arg2?: string) => void
  onUnlike?: (arg: { contentType?: string; nid?: number }, arg2?: string) => void
}

const AuthorArticlesCollection: FC<ArticlesCollectionProps> = ({
  title,
  totalCount,
  items,
  page,
  pageCount,
  onPageChange,
  onLike,
  onUnlike,
}) => {
  return (
    <Container maxWidth={1480} pt={{ xs: 15, lg: 30 }}>
      <ArticlesCollectionHeader title={title} totalCount={totalCount} />
      <BlogArticleCollection items={items} onLike={onLike} onUnlike={onUnlike} />
      <Box pt={15} pb={{ xs: 15, md: 11 }}>
        <Pagination page={page} count={pageCount} onPageChange={onPageChange as () => void} />
      </Box>
    </Container>
  )
}

export default AuthorArticlesCollection

/** A sub-component for the articles collection header */
const ArticlesCollectionHeader: FC<Pick<ArticlesCollectionProps, "title" | "totalCount">> = ({
  title,
  totalCount,
}) => {
  return (
    <Box display="flex" gap={2} mb={{ xs: 6, lg: 10 }}>
      <Typography variant="heading.lg" component="h2">{title}</Typography>
      <Typography variant="body.sm" component={"sup"}>
        {totalCount}
      </Typography>
    </Box>
  )
}
